<template>
    <v-container>
        <h1 class="mb-4">Users</h1>
        <div class="table-options">
            <v-btn class="my-2 create-button" dark small color="primary" :loading="creating" :disabled="creating || deletingId !== null || editingId !== null" @click="createUser">
                <v-icon dark>mdi-plus</v-icon>Create
            </v-btn>
        </div>
        <v-data-table
            item-key="id"
            :headers="headers"
            :items="users"
        >
            <template slot="item" slot-scope="props">
                <tr>
                    <td @click="handleClick('show', props.item)">{{ props.item.email }}</td>
                    <td @click="handleClick('show', props.item)">
                        <div v-if="props.item.partner">
                            {{ props.item.partner.title }}
                        </div>
                    </td>
                    <td>
                        <div class="buttons">
                            <v-btn class="mx-2" dark small color="primary" :loading="editingId === props.item.id" :disabled="editingId !== null || creating || deletingId !== null" @click="handleClick('edit', props.item)">
                                <v-icon dark>mdi-account-edit</v-icon>
                            </v-btn>
                            <delete-button :loading="deletingId === props.item.id" @delete-entry="onDelete(props.item)" />
                        </div>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    import userService from '@/services/user-service'
    import DeleteButton from '@/components/DeleteButton'
    export default {
        name: 'TeamRoute',
        components: { DeleteButton },
        data: () => {
            return {
                users: [],
                creating: false,
                editingId: null,
                deletingId: null,
                headers: [{
                              text: 'Email',
                              value: 'email',
                              align: 'left',
                              sortable: true
                          },
                          { text: 'Partner', value: 'partner' },
                          {
                              text: 'Actions',
                              value: 'actions',
                              align: 'center',
                              sortable: false
                          }]
            }
        },
        created() {
            this.fetchAllUsers()
        },
        methods: {
            async handleClick(mode, item) {
                this.editingId = item.id
                try {
                    await this.$router.push(`/users/${item.id}/${mode}`)
                } finally {
                    this.editingId = null
                }
            },
            async onDelete(item) {
                this.deletingId = item.id
                await userService.deleteUserById(item.id).then(() => {
                    this.fetchAllUsers()
                })
                this.deletingId = null
            },
            async createUser() {
                this.creating = true
                try {
                    await this.$router.push(`/users/create`)
                } finally {
                    this.creating = false
                }
            },
            fetchAllUsers() {
                userService.getAllUsers().then(resp => {
                    this.users = resp.data.data
                })
            }
        }
    }
</script>

<style scoped>
.search {
    max-width: 300px;
}
.table-options {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}
td {
    min-width: 150px;
}
.buttons {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
}
</style>




